// extracted by mini-css-extract-plugin
export default {"landingItems":"_84f516b","landingItem":"_1a571d78","isHorizontal":"_211690ae","spinner":"_6efb6ad7","isUnpurchasable":"_187c552f"};